import { State } from '../../../types/state';
import { theme } from '../../../themes/default/theme';

export const themeSelector = (state: State) => theme;